import { render, staticRenderFns } from "./PolicyWizardScreen.vue?vue&type=template&id=123e3784&"
import script from "./PolicyWizardScreen.vue?vue&type=script&lang=js&"
export * from "./PolicyWizardScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports